import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Namuna7Receipt from './Namuna7Receipt';

const Aarthikreportnamuna7 = () => {
  const [fromDate, setFromDate] = useState('2025-04-01');
  const [toDate, setToDate] = useState('2025-04-01');
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const navigate = useNavigate();

  // Sample data for the table
  const [tableData] = useState([
    {
      id: 1,
      date: '01/04/2025',
      receiptNo: 'R001',
      personName: 'राम शर्मा',
      accountName: 'ग्राम खाते',
      creditAmount: '5000',
      remark: 'जमा रक्कम'
    },
    {
      id: 2,
      date: '02/04/2025',
      receiptNo: 'R002',
      personName: 'सीता देशमुख',
      accountName: 'विकास निधी',
      creditAmount: '3000',
      remark: 'देणी'
    },
    {
      id: 3,
      date: '03/04/2025',
      receiptNo: 'R003',
      personName: 'गणेश पाटील',
      accountName: 'पाणी निधी',
      creditAmount: '2000',
      remark: 'पाणी बिल'
    }
  ]);

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value);
  };

  const handleGenerateReceipt = (row) => {
    // Map row data to Namuna7Receipt expected format
    const formattedTransaction = {
      date: row.date.split('/').reverse().join('-'), // Convert dd/mm/yyyy to yyyy-mm-dd if needed, or keep as is if component handles it. 
      // Actually component expects yyyy-mm-dd or anything Date constructor takes. 
      // row.date is '01/04/2025'. Date('01/04/2025') might be invalid in some browsers (US format expectation).
      // Let's ensure standard format or pass as is if formatAmount handles it.
      // Namuna7Receipt uses new Date(dateString). '01/04/2025' might be read as Jan 4th or April 1st.
      // Let's parse it manually to yyyy-mm-dd for safety.

      challanNo: row.receiptNo,
      personName: row.personName,
      totalAmount: parseFloat(row.creditAmount),
      transactions: [
        {
          accountName: row.accountName,
          narration: row.remark,
          amount: parseFloat(row.creditAmount)
        }
      ]
    };

    // Fix date format manually since row.date is dd/mm/yyyy
    const [day, month, year] = row.date.split('/');
    formattedTransaction.date = `${year}-${month}-${day}`;

    setSelectedReceipt(formattedTransaction);
  };

  const handleShow = () => {
    console.log('Show clicked:', { fromDate, toDate });
  };

  const handleReport = () => {
    console.log('Report clicked:', { fromDate, toDate });
  };

  const handleBack = () => {
    navigate('/aarthikreport');
  };

  if (selectedReceipt) {
    return (
      <Namuna7Receipt
        transaction={selectedReceipt}
        onBack={() => setSelectedReceipt(null)}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">

          {/* Header */}
          <div className="bg-[#267c77] text-white px-6 py-4 text-center">
            <h1 className="text-xl font-bold">नमुना 7 यादी</h1>
          </div>

          {/* Back Button */}
          <div className="px-6 py-4 bg-gray-50 border-b">
            <button
              onClick={handleBack}
              className="flex items-center gap-2 bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 transition-colors duration-200"
            >
              ← Back
            </button>
          </div>

          {/* Form Content */}
          <div className="p-6">
            <div className="space-y-6">

              {/* Date Range Fields */}
              <div className="flex items-center space-x-4">
                <label className="text-gray-700 font-medium w-32">
                  दिनांका पासुन
                </label>
                <div className="relative flex-1">
                  <input
                    type="date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#267c77] focus:border-transparent"
                  />
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <label className="text-gray-700 font-medium w-32">
                  दिनांका पर्यंत
                </label>
                <div className="relative flex-1">
                  <input
                    type="date"
                    value={toDate}
                    onChange={handleToDateChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#267c77] focus:border-transparent"
                  />
                </div>
              </div>

              {/* Buttons */}
              <div className="flex items-center space-x-4">
                <div className="w-32"></div>
                <div className="flex space-x-4">
                  <button
                    onClick={handleShow}
                    className="bg-[#267c77] text-white px-6 py-2 rounded-md hover:bg-[#1f6360] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#267c77] focus:ring-offset-2"
                  >
                    दाखवा
                  </button>
                  <button
                    onClick={handleReport}
                    className="bg-[#267c77] text-white px-6 py-2 rounded-md hover:bg-[#1f6360] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#267c77] focus:ring-offset-2"
                  >
                    रिपोर्ट
                  </button>
                </div>
              </div>

            </div>

            {/* Table */}
            <div className="mt-8">
              <div className="bg-[#267c77] text-white px-6 py-3">
                <h2 className="text-lg font-semibold">नमुना 7 माहिती</h2>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-2 text-left text-sm font-medium text-gray-700">दिनांक</th>
                      <th className="border border-gray-300 px-4 py-2 text-left text-sm font-medium text-gray-700">पावती नं.</th>
                      <th className="border border-gray-300 px-4 py-2 text-left text-sm font-medium text-gray-700">व्यक्तीचे नाव</th>
                      <th className="border border-gray-300 px-4 py-2 text-left text-sm font-medium text-gray-700">खात्याचे नाव</th>
                      <th className="border border-gray-300 px-4 py-2 text-left text-sm font-medium text-gray-700">जमा रक्कम</th>
                      <th className="border border-gray-300 px-4 py-2 text-left text-sm font-medium text-gray-700">शेरा</th>
                      <th className="border border-gray-300 px-4 py-2 text-left text-sm font-medium text-gray-700">पर्याय</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row) => (
                      <tr key={row.id} className="hover:bg-gray-50">
                        <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">{row.date}</td>
                        <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">{row.receiptNo}</td>
                        <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">{row.personName}</td>
                        <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">{row.accountName}</td>
                        <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">{row.creditAmount}</td>
                        <td className="border border-gray-300 px-4 py-2 text-sm text-gray-900">{row.remark}</td>
                        <td className="border border-gray-300 px-4 py-2 text-sm text-center">
                          <button
                            onClick={() => handleGenerateReceipt(row)}
                            className="bg-green-600 text-white px-4 py-1 rounded text-sm hover:bg-green-700 transition-colors duration-200"
                          >
                            नमुना 7
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="mt-4 flex justify-between items-center px-4">
                <div className="text-sm text-gray-600">
                  Showing 1 to {tableData.length} of {tableData.length} entries
                </div>
                <div className="flex space-x-2">
                  <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-100 text-sm">Previous</button>
                  <button className="px-3 py-1 bg-[#267c77] text-white rounded text-sm">1</button>
                  <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-100 text-sm">Next</button>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Aarthikreportnamuna7;